if (!customElements.get('slider-default')) {
  class SliderDefault extends HTMLElement {
    constructor() {
      super();

      this.sliderOptions = {
        slidesPerView: 'auto',
        centeredSlides: this.hasAttribute('data-center-slides'),
        loop: this.hasAttribute('data-loop'),
        watchSlidesProgress: this.hasAttribute('data-watch-slides'),
        speed: this.hasAttribute('data-speed') ? +this.dataset.speed : 300,
        freeMode: {
          enabled: true,
          sticky: true,
        },
      };

      this.initSlider();
    }

    initSlider() {
      const nextEl = this.querySelector('.js-next');
      const prevEl = this.querySelector('.js-prev');

      this.sliderOptions.navigation = {
        nextEl: nextEl,
        prevEl: prevEl,
      };

      this.slider = new Swiper(
        this.querySelector('.js-slider'),
        this.sliderOptions,
      );
    }
  }

  customElements.define('slider-default', SliderDefault);
}
